<!--
 * @Author: your name
 * @Date: 2021-02-25 18:36:14
 * @LastEditTime: 2021-03-05 16:06:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \wizplant-ui\src\components\tableRelated\columnVisible.vue
-->
<template>
  <div id="columnVisible">
    <el-popover ref="popover2" placement="bottom" title="显示的列" trigger="click">
      <el-checkbox-group v-model="columnVisible">
        <div v-for="(item, index) in options" :key="index">
          <el-checkbox :label="item.value" :key="item.value">{{ $t(item.label) }}</el-checkbox>
        </div>
      </el-checkbox-group>
    </el-popover>
    <el-button v-popover:popover2>{{ $t('filterColumns') }} </el-button>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'columnVisible',
  props: ['options', 'defaultValue', 'name'],
  components: {},
  data() {
    return {
      columnVisible: this.defaultValue || [],
      // name: null,
    }
  },
  watch: {
    defaultValue: {
      deep: true,
      handler(val) {
        this.columnVisible = val
      },
    },
    columnVisible: {
      deep: true,
      handler() {
        localforage.setItem(this.name[0], this.columnVisible).then(() => {
          this.$emit('columnVisibleChanged', this.columnVisible)
        })
      },
    },
  },
  created() {
    // this.name = this.$route.path
    localforage.getItem(this.name[0]).then((res) => {
      if (!_.isNull(res)) {
        if (res.length !== 0) {
          this.columnVisible = res
        } else {
          this.columnVisible = this.defaultValue
        }
      }
    })
  },
}
</script>
<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>

.el-button--medium {
  padding: 9px 20px !important;
}

</style>
<style lang="scss">

#columnVisible {
  .el-button--medium {
    font-size: 12px;
  }
}

</style>
